var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setRemConfig, remUnit, toPx } from '@max/leez-style-util';
import { createElement, memo, useState, useRef, useEffect, useContext } from '@max/max';
import { getNetworkType } from '@max/meituan-uni-networkInfo';
import { requestDataCenter } from './api';
import ToastManager from '@max/leez-toast-manager';
import Toast from '@max/leez-toast';
import Modal from '@max/leez-modal';
import TopView from '@max/leez-top-view';
import { getUserInfo, login } from '@nibfe/mkt-user-api';
import { getSystemInfo } from '@max/meituan-uni-system';
import { eventOn, eventOff } from '@max/meituan-uni-event';
import { getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import { navigateTo } from '@max/meituan-uni-navigate';
import View from '@hfe/max-view';
import Button from '@hfe/max-button';
import Image from '@max/leez-image';
import Text from '@max/leez-text';
import { PLAY_STATUS, LiveClearity, QueryGoal, ReserveTipWay, LIVE_DOING_IMAGE, RIGHT_ARROW, LIVE_FINISH_DASH_LINE_END, LIVE_FINISH_DASH_LINE_FRONT } from './constants';
import { styles } from './styles';
import Player from "./components/player/index.web";
const isWeb = true;
import Sensor from '@max/mbc-sensor';
const LiveRoomReserve = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    setRemConfig({
        enabled: true
    });
    // @ts-expect-error no global
    const ctx = useContext(global._EngineGlobalContext);
    const imageRate = 1.5;
    const platformType = getPlatformType();
    const { anchorId, liveWindowWidth, liveWindowHeight, liveWindowX, liveWindowY, notStartFrontCover, finishedFrontCover, notStartBorderImg, livingBorderImg, finishedBorderImg, waitReserveButtonImg, reservedButtonImg, reserveButtonX, reserveButtonY, ifToLiveRoomReserve, reserveSuccess, reserveFail, _runtimeInfo } = props;
    const userInfo = useRef({
        token: '',
        avatarURL: '',
        uuid: '',
        userId: '',
        userName: '',
        done: false
    });
    const reqCommonParams = useRef({
        uuid: '',
        userId: '',
        appId: '0',
        platform: 0,
        clearity: LiveClearity.LD,
        isFromH5: false
    });
    const [state, setState] = useState({
        liveId: (props === null || props === void 0 ? void 0 : props.liveId) || '',
        pullStreamUrl: '',
        playStatus: -1,
        singleLiveUrl: '',
        ifReserved: false,
        modalVisible: false,
        durationTime: '',
        isVideoPlaying: PLAY_STATUS.LIVE_NOTSTRAT
    });
    const [borderImg, setBorderImg] = useState({
        url: '',
        width: '0',
        height: '0'
    });
    const [fontCoverInfo, setFontCoverInfo] = useState({
        frontCoverImg: {
            url: '',
            width: '0',
            height: '0'
        },
        frontCoverUrl: {
            mtUrl: '',
            dpUrl: ''
        }
    });
    const [reserveButtonInfo, setReserveButtonInfo] = useState({
        url: '',
        width: '0',
        height: '0'
    });
    const getLiveClearity = () => {
        return new Promise(resolve => {
            getNetworkType().then((res) => {
                const networkType = res === null || res === void 0 ? void 0 : res.networkType;
                if (networkType === 'wifi') {
                    resolve(LiveClearity.origin);
                }
                else if (networkType === '5g') {
                    resolve(LiveClearity.HD);
                }
                else if (networkType === '4g') {
                    resolve(LiveClearity.SD);
                }
                else {
                    resolve(LiveClearity.LD);
                }
            }).catch(() => {
                resolve(LiveClearity.LD);
            });
        });
    };
    const handleReqDataCenter = (queryGoal, userInfo) => __awaiter(void 0, void 0, void 0, function* () {
        const { uuid, clearity, userId, appId, platform, isFromH5 } = reqCommonParams.current;
        const queryExtraParams = queryGoal === QueryGoal.LIVE_INFO && state.liveId ? {
            liveId: state.liveId
        } : {};
        const reserveReqParams = queryGoal === QueryGoal.LIVE_RESERVE ? {
            userId,
            liveId: state.liveId
        } : {}; // 预约直播额外请求参数
        const componentRequestParams = {
            componentProps: !props.moduleType ? Object.assign(Object.assign({}, props), { userInfo: userInfo.current, moduleType: 'tex-max-live-room-reserve' }) : Object.assign(Object.assign({}, props), { userInfo: userInfo.current }),
            requestParams: {
                body: {
                    moduleParam: Object.assign(Object.assign({ anchorId, deviceId: uuid, platform,
                        appId, networkStatus: clearity, queryGoal,
                        userId, queryAllPlayStatus: true, 
                        // 默认是false，即只查询直播中的信息，本次需求需传为True
                        isFromH5 }, queryExtraParams), reserveReqParams)
                }
                // devHost: 'https://ihotel.meituan.com',
            },
            isCombo: true,
            comboCallback: (data) => handleDataCenterResponse(data, queryGoal)
        };
        requestDataCenter(componentRequestParams);
    });
    const handleDataCenterResponse = (data, queryGoal) => {
        const { liveBaseInfo: { liveId = -1, pullStreamUrl = '', playStatus = PLAY_STATUS.LIVE_FINISH, singleLiveUrl = '', durationTime = '' } = {}, reservationInfo: { remind } = {}, code } = data || {};
        // 查询直播间信息 && 预约直播间信息刷新状态
        if (queryGoal === QueryGoal.LIVE_INFO) {
            if (code === 0 && liveId) {
                setState((prevState) => (Object.assign(Object.assign({}, prevState), { liveId: liveId.toString(), pullStreamUrl,
                    playStatus,
                    singleLiveUrl, ifReserved: remind, durationTime })));
            }
        }
        // 直播间预约结果
        const { reserveSuccess, reserveFail } = props !== null && props !== void 0 ? props : {};
        if (queryGoal === QueryGoal.LIVE_RESERVE) {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { ifReserved: code === 0 })));
            if (code === 0 && (reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.tipWaySelect) === ReserveTipWay.MODAL || (reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.tipWaySelect) === ReserveTipWay.MODAL) {
                setState((prevState) => (Object.assign(Object.assign({}, prevState), { modalVisible: true })));
                return;
            }
            if (code === 0 && (reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.tipWaySelect) === ReserveTipWay.TOAST || (reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.tipWaySelect) === ReserveTipWay.TOAST) {
                Toast.open({
                    content: code === 0 ? reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.reserveSuccessToastText : reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.reserveFailToastText
                });
            }
        }
    };
    function BuildPlayer() {
        var _a, _b;
        return <Player liveWindowWidth={Number(liveWindowWidth)} liveWindowHeight={Number(liveWindowHeight)} liveId={state.liveId.toString()} videoUrl={state.pullStreamUrl} posterUrl={((_b = (_a = props.notStartFrontCover) === null || _a === void 0 ? void 0 : _a.frontCoverImg) === null || _b === void 0 ? void 0 : _b.url) || ''} isPlaying={state.isVideoPlaying} rootTag={_runtimeInfo.rootTag} onVideoError={() => {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { playStatus: PLAY_STATUS.LIVE_FINISH })));
            //   -100 启动播放失败，可能是playUrl为空或者非法
            //   -101 网络断连，且经多次重连抢救无效
            //   -102 MTLive checkengine 失败
        }} onVideoCompleted={() => {
            handleReqDataCenter(QueryGoal.LIVE_INFO, userInfo.current);
        }} handleVideoPlaying={handleVideoPlaying}/>;
    }
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            userInfo.current = yield getUserInfo();
            if (!((_a = userInfo.current) === null || _a === void 0 ? void 0 : _a.userId) && !((_b = userInfo.current) === null || _b === void 0 ? void 0 : _b.token)) {
                userInfo.current = yield login();
            }
            const clearity = (yield getLiveClearity());
            const appID = (_c = (yield getSystemInfo().then((res) => res === null || res === void 0 ? void 0 : res.appID))) !== null && _c !== void 0 ? _c : '';
            if (anchorId) {
                const { uuid, userId } = userInfo.current;
                const params = {
                    uuid,
                    userId,
                    appId: isWeb ? platformType === PlatformType.dpApp || platformType === PlatformType.dpMinaWebview || platformType === PlatformType.dpAppWebView ? "1" : "10" : appID,
                    platform: platformType === PlatformType.dpApp || platformType === PlatformType.dpMinaWebview || platformType === PlatformType.dpAppWebView ? 1 : 2,
                    isFromH5: isWeb ? true : false,
                    clearity
                };
                reqCommonParams.current = params;
                yield handleReqDataCenter(QueryGoal.LIVE_INFO, userInfo);
            }
        });
        fetchData();
        eventOn({
            action: 'containerViewDidAppear',
            handle: refreshData
        });
        // 清理函数
        return () => {
            eventOff({
                action: 'containerViewDidAppear',
                subId: null
            });
        };
    }, []);
    // 跳转页面回来时刷新数据
    const refreshData = (result) => {
        if (result && (result === null || result === void 0 ? void 0 : result.rootTag) === _runtimeInfo.rootTag) {
            handleReqDataCenter(QueryGoal.LIVE_INFO, userInfo);
        }
    };
    // 获取直播间边框图
    const handleBorderImgInfo = () => {
        const { playStatus } = state;
        switch (playStatus) {
            case PLAY_STATUS.LIVE_NOTSTRAT:
                return notStartBorderImg;
            case PLAY_STATUS.LIVE_DOING:
                return livingBorderImg;
            case PLAY_STATUS.LIVE_FINISH:
                return finishedBorderImg;
            default:
                return finishedBorderImg;
        }
    };
    useEffect(() => {
        setBorderImg(handleBorderImgInfo());
    }, [state.playStatus]);
    // 获取直播间封面图
    const handleFontCoverImg = () => {
        const { playStatus } = state;
        switch (playStatus) {
            case PLAY_STATUS.LIVE_NOTSTRAT:
                return notStartFrontCover;
            case PLAY_STATUS.LIVE_FINISH:
                return finishedFrontCover;
            default:
                return finishedFrontCover;
        }
    };
    useEffect(() => {
        setFontCoverInfo(handleFontCoverImg());
    }, [state.playStatus]);
    // 直播间封面跳转
    const handleClickLiveRoom = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        ctx._LXReport.mcReportWithTag('b_hotel_uawtqnvy_mc', {
            valLab: {
                zhibo_id: state.liveId,
                zhibo_status: state.playStatus
            },
            tagContent: {
                zhibo_id: state.liveId,
                zhibo_status: state.playStatus
            }
        });
        if (state.playStatus === PLAY_STATUS.LIVE_NOTSTRAT && (((_a = notStartFrontCover === null || notStartFrontCover === void 0 ? void 0 : notStartFrontCover.frontCoverUrl) === null || _a === void 0 ? void 0 : _a.mtUrl) || ((_b = notStartFrontCover === null || notStartFrontCover === void 0 ? void 0 : notStartFrontCover.frontCoverUrl) === null || _b === void 0 ? void 0 : _b.dpUrl))) {
            navigateTo({
                url: PlatformType.mtApp ? (_c = notStartFrontCover === null || notStartFrontCover === void 0 ? void 0 : notStartFrontCover.frontCoverUrl) === null || _c === void 0 ? void 0 : _c.mtUrl : (_d = notStartFrontCover === null || notStartFrontCover === void 0 ? void 0 : notStartFrontCover.frontCoverUrl) === null || _d === void 0 ? void 0 : _d.dpUrl
            });
            return;
        }
        if (state.playStatus === PLAY_STATUS.LIVE_FINISH && (((_e = finishedFrontCover === null || finishedFrontCover === void 0 ? void 0 : finishedFrontCover.frontCoverUrl) === null || _e === void 0 ? void 0 : _e.mtUrl) || ((_f = finishedFrontCover === null || finishedFrontCover === void 0 ? void 0 : finishedFrontCover.frontCoverUrl) === null || _f === void 0 ? void 0 : _f.dpUrl))) {
            navigateTo({
                url: PlatformType.mtApp ? (_g = finishedFrontCover === null || finishedFrontCover === void 0 ? void 0 : finishedFrontCover.frontCoverUrl) === null || _g === void 0 ? void 0 : _g.mtUrl : (_h = finishedFrontCover === null || finishedFrontCover === void 0 ? void 0 : finishedFrontCover.frontCoverUrl) === null || _h === void 0 ? void 0 : _h.dpUrl
            });
            return;
        }
        // 直播中或未配置直播间未开始、已结束跳转链接时，跳转至直播间详情页
        if (state.singleLiveUrl) {
            navigateTo({
                url: state.singleLiveUrl
            });
        }
    };
    // 获取预约按钮
    const handleReserveButtonImg = () => {
        return state.ifReserved ? reservedButtonImg : waitReserveButtonImg;
    };
    useEffect(() => {
        setReserveButtonInfo(handleReserveButtonImg());
    }, [state.ifReserved]);
    // 点击按钮预约
    const handleClickReserveButton = () => __awaiter(void 0, void 0, void 0, function* () {
        ctx._LXReport.mcReport('b_hotel_0lwxzsva_mc', {
            valLab: {
                zhibo_id: state.liveId,
                zhibo_status: state.playStatus
            }
        });
        // 进入直播间预约
        if (ifToLiveRoomReserve && state.singleLiveUrl) {
            navigateTo({
                url: state.singleLiveUrl
            });
            return;
        }
        // 不进入直播间预约
        yield handleReqDataCenter(QueryGoal.LIVE_RESERVE, userInfo);
    });
    // 点击弹窗图片
    const handleModalImg = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (state.ifReserved && (((_a = reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.reserveSuccessUrl) === null || _a === void 0 ? void 0 : _a.mtUrl) || ((_b = reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.reserveSuccessUrl) === null || _b === void 0 ? void 0 : _b.dpUrl))) {
            navigateTo({
                url: PlatformType.mtApp ? (_c = reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.reserveSuccessUrl) === null || _c === void 0 ? void 0 : _c.mtUrl : (_d = reserveSuccess === null || reserveSuccess === void 0 ? void 0 : reserveSuccess.reserveSuccessUrl) === null || _d === void 0 ? void 0 : _d.dpUrl
            });
            return;
        }
        if (!state.ifReserved && (((_e = reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.reserveFailUrl) === null || _e === void 0 ? void 0 : _e.mtUrl) || ((_f = reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.reserveFailUrl) === null || _f === void 0 ? void 0 : _f.dpUrl))) {
            navigateTo({
                url: PlatformType.mtApp ? (_g = reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.reserveFailUrl) === null || _g === void 0 ? void 0 : _g.mtUrl : (_h = reserveFail === null || reserveFail === void 0 ? void 0 : reserveFail.reserveFailUrl) === null || _h === void 0 ? void 0 : _h.dpUrl
            });
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { modalVisible: false })));
    };
    // 处理配置图片及样式宽高
    const handleRem = (dimensions, ifImageDetail = false) => {
        if (ifImageDetail) {
            return remUnit(Math.floor(Number(dimensions) / imageRate));
        }
        else {
            return remUnit(Number(dimensions));
        }
    };
    const handleVideoPlaying = (value) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { isVideoPlaying: value })));
    };
    if (state.playStatus === -1) {
        return null;
    }
    const outerStyle = {
        marginTop: `${Number(liveWindowY) * 2}rpx`,
        marginLeft: `${Number(liveWindowX) * 2}rpx`
    };
    const liveWindowStyle = {
        height: `${Number(liveWindowHeight) * 2}rpx`,
        width: `${Number(liveWindowWidth) * 2}rpx`
    };
    return <>
      <Sensor once onAppear={() => {
        ctx._LXReport.mvReport('b_hotel_iqhoyq6h_mv', {
            valLab: {
                zhibo_id: state.liveId,
                zhibo_status: state.playStatus
            }
        });
    }}>
        <View style={{
        flex: 1,
        flexDirection: "column",
        width: '750rpx',
        height: '100%'
    }}>
          <Image source={{
        uri: borderImg.url
    }}>
            <View style={[styles.container, outerStyle]}>
              {state.playStatus === PLAY_STATUS.LIVE_NOTSTRAT || state.playStatus === PLAY_STATUS.LIVE_FINISH ? <Button onPress={handleClickLiveRoom}>
                  <View style={styles.finishRoomContainer}>
                    <Image source={{
        uri: (_a = fontCoverInfo === null || fontCoverInfo === void 0 ? void 0 : fontCoverInfo.frontCoverImg) === null || _a === void 0 ? void 0 : _a.url
    }} height={toPx(Number((_b = fontCoverInfo === null || fontCoverInfo === void 0 ? void 0 : fontCoverInfo.frontCoverImg) === null || _b === void 0 ? void 0 : _b.height))} width={toPx(Number((_c = fontCoverInfo === null || fontCoverInfo === void 0 ? void 0 : fontCoverInfo.frontCoverImg) === null || _c === void 0 ? void 0 : _c.width))}/>
                    {state.playStatus === PLAY_STATUS.LIVE_FINISH ? <View style={styles.finishDescContainer}>
                        <View style={styles.finishTextContainer}>
                          <Image source={{
        uri: LIVE_FINISH_DASH_LINE_FRONT
    }} width={toPx(40)} height={toPx(1)}/>
                          <Text style={styles.finishText}>直播已结束</Text>
                          <Image source={{
        uri: LIVE_FINISH_DASH_LINE_END
    }} width={toPx(40)} height={toPx(1)}/>
                        </View>
                        {state.durationTime ? <Text style={styles.durationTimeText}>直播时长{state.durationTime}</Text> : null}
                      </View> : null}
                  </View>
                </Button> : null}
              {state.playStatus === PLAY_STATUS.LIVE_DOING ? <Button onPress={handleClickLiveRoom}>
                  <View style={styles.liveRoomContainer}>
                    <View style={liveWindowStyle}>
                      {BuildPlayer()}
                    </View>
                    <View style={styles.livingRoomHeaderContainer}>
                      <Image source={{
        uri: LIVE_DOING_IMAGE
    }} height={toPx(15)} width={toPx(15)}/>
                      <Text style={styles.livingRoomHeaderText}>直播中</Text>
                    </View>
                    <View style={styles.jumpToLiveRoomContainer}>
                      <Text style={styles.jumpToLiveRoomText}>{state.isVideoPlaying === PLAY_STATUS.LIVE_DOING ? "点击进入直播间" : state.isVideoPlaying === PLAY_STATUS.LIVE_NOTSTRAT ? "点击查看直播" : ""}</Text>
                      <Image source={{
        uri: RIGHT_ARROW
    }} height={toPx(12)} width={toPx(12)}/>
                    </View>
                  </View>
                </Button> : null}
            </View>
            
            {state.playStatus === PLAY_STATUS.LIVE_NOTSTRAT ? <View style={[{
            justifyContent: 'center',
            marginTop: handleRem(reserveButtonY),
            marginLeft: handleRem(reserveButtonX)
        }]}>
                <Button onPress={state.ifReserved ? handleClickLiveRoom : handleClickReserveButton}>
                <View style={styles.finishRoomContainer}>
                  <Image source={{
        uri: reserveButtonInfo === null || reserveButtonInfo === void 0 ? void 0 : reserveButtonInfo.url
    }} height={toPx(Number(reserveButtonInfo === null || reserveButtonInfo === void 0 ? void 0 : reserveButtonInfo.height))} width={toPx(Number(reserveButtonInfo === null || reserveButtonInfo === void 0 ? void 0 : reserveButtonInfo.width))} resizeMode='contain'/>
                </View>
              </Button>
              </View> : null}
          </Image>
        </View>
      </Sensor>

      <TopView>
        <Modal visible={state.modalVisible} showCloseBtn={true} maskClosable={true} onClosePress={() => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { modalVisible: false })));
    }}>
          <View style={{
        alignItems: 'center'
    }}>
            <Button onPress={handleModalImg}>
              <Image source={{
        uri: (state.ifReserved ? (_d = reserveSuccess.reserveSuccessModalImg) === null || _d === void 0 ? void 0 : _d.url : (_e = reserveFail.reserveFailModalImg) === null || _e === void 0 ? void 0 : _e.url) || ''
    }} height={toPx(Number(state.ifReserved ? (_f = reserveSuccess.reserveSuccessModalImg) === null || _f === void 0 ? void 0 : _f.height : (_g = reserveFail.reserveFailModalImg) === null || _g === void 0 ? void 0 : _g.height))} width={toPx(Number(state.ifReserved ? (_h = reserveSuccess.reserveSuccessModalImg) === null || _h === void 0 ? void 0 : _h.width : (_j = reserveFail.reserveFailModalImg) === null || _j === void 0 ? void 0 : _j.width))}/>
            </Button>
          </View>
        </Modal>
      </TopView>
      <ToastManager />
    </>;
};
export function _customPVReportParams(params) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        return {
            custom: {
                hotel_channel: ((_a = params === null || params === void 0 ? void 0 : params.queryParams) === null || _a === void 0 ? void 0 : _a['hotelchannel']) || '-999',
                tex_id: ((_b = params === null || params === void 0 ? void 0 : params.queryParams) === null || _b === void 0 ? void 0 : _b['pageId']) || '-999'
            }
        };
    });
}
export default memo(LiveRoomReserve);
